import { render, staticRenderFns } from "./PositionHistory.vue?vue&type=template&id=aae989c8&scoped=true"
import script from "./PositionHistory.vue?vue&type=script&lang=js"
export * from "./PositionHistory.vue?vue&type=script&lang=js"
import style0 from "./PositionHistory.vue?vue&type=style&index=0&id=aae989c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae989c8",
  null
  
)

export default component.exports